import http from '@/services/BackendService'

// ชั้นเดียวที่รู้ URL + response key ของฟีเจอร์ announcement (build บน BackendService)
export default {
    // ฟีดประกาศที่นักเรียนเห็นได้ (option ค้นหา title + pagination)
    async fetchFeed(q, page) {
        const { data } = await http.get('announcement', {
            params: { q: q || undefined, page: page || undefined },
        })
        return data // { success, data: [...cards], meta }
    },

    // ประกาศ active (payload เบา) สำหรับ popup หน้าแรก
    async fetchActive() {
        const { data } = await http.get('announcement/active')
        return data.data
    },

    // ประกาศเดี่ยว (เนื้อหาเต็ม + ไฟล์แนบ)
    async fetchDetail(id) {
        const { data } = await http.get(`announcement/${id}`)
        return data.data
    },

    // บันทึกว่าอ่านแล้ว (v2: เก็บลง DB แทน localStorage) → คืน read_count ล่าสุด
    async markRead(id) {
        const { data } = await http.post(`announcement/${id}/read`)
        return data.data // { read_count, staff_reads, student_reads }
    },
}
